<template>
  <v-card class="rounded-card card-shadow" color="primary">
    <v-card-title class="white--text font-weight-bold pl-5">
      <v-icon x-large left color="white">mdi-chart-donut</v-icon>
      Comissão
    </v-card-title>
    <v-card-text v-if="!loading && !comissao"
      class="text--primary dashboard-empty-div d-flex align-center justify-center">
      <span class="white--text font-weight-bold">
        Nenhum dado encontrado para o período
      </span>
    </v-card-text>
    <v-card-text v-else
                 class="text--primary dashboard-comissao">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div v-if="!loading && comissao"
           class="d-flex flex-column justify-space-around fill-height">
        <div class="d-flex justify-space-around">
          <div class="text-center">
          <span class="white--text headline font-weight-bold">
            {{ comissao.comissao | currency }}
          </span>
            <div class="white--text body-2">
              ~{{ percentualComissao | number('0.00') }}% por venda
            </div>
          </div>
          <div class="text-center">
          <span class="white--text headline font-weight-bold">
            {{ comissao.roi | number('0.00') }}
          </span>
            <div class="white--text body-2">
              ROI
            </div>
          </div>
        </div>
        <div class="d-flex justify-space-between align-center mx-12 mt-8">
          <div class="white--text body-1">
            Receita bruta
          </div>
          <div class="white--text headline font-weight-bold">
            {{ comissao.total | currency }}
          </div>
        </div>
        <div class="d-flex flex-column">
          <v-divider class="white"/>
          <div class="d-flex justify-space-between align-center mt-4 mx-12">
            <div class="white--text">
              <h3>Receita líquida</h3>
            </div>
            <div class="white--text headline font-weight-bold">
              {{ comissao.totalLiquido | currency }}
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import currency from 'currency.js';
import IndicadoresMarketplaceService from './indicadores-marketplace';

export default {
  props: {
    stateDate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      comissao: null,
      loading: false,
    };
  },
  computed: {
    query() {
      return `dataCompra >= ${this.stateDate.initialDate} and dataCompra <= ${this.stateDate.finalDate}`;
    },
    percentualComissao() {
      return this.comissao ? currency(this.comissao.percentualComissao, { precision: 4 })
        .multiply(100) : 0;
    },
  },
  methods: {
    getComissao() {
      this.loading = true;
      IndicadoresMarketplaceService.getComissaoFornecedor({
        query: this.query,
      })
        .then(({ data }) => {
          this.comissao = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    stateDate(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getComissao();
    },
  },
  created() {
    this.getComissao();
  },
};
</script>

<style scoped>
.dashboard-empty-div {
  height: 280px;
}

.dashboard-comissao {
  height: 280px;
}
</style>
